/**
 * This file helps us export data to crm providers.
 *
 * Basically, we're sending visit/property/search data to providers.
 *
 * It integrates with the backend folders /Paths/Exports/**
 *
 */

const EAP_EXPORT_ID_COOKIE = 'eap_export_id';
const EAP_EXPORT_VISIT_DATA = 'eap_export';
export const TYPES_OF_EVENTS = {
	PROPERTY: 'property_viewed',
	SEARCH: 'search_performed',
	VISIT: 'visit',
	PROP_FAV: 'favorite_property_added',
};
const EXPORT_TYPES_WHERE_PROPERTY_NEEDED = [TYPES_OF_EVENTS.PROPERTY, TYPES_OF_EVENTS.PROP_FAV];

const cookieFactory = (type, description) => {
	const cookie = {};
	cookie.type = type;
	cookie.url = window.location.href;
	cookie.pagename = window.document.title;
	cookie.timestamp = window.eap_tracker.timestamp;
	cookie.description = description;

	if (EXPORT_TYPES_WHERE_PROPERTY_NEEDED.includes(type)) {
		if (jQuery('#eap-new-container.ihf-listing-detail').length > 0) {
			cookie.property = {
				mls: jQuery('#eap-new-container.ihf-listing-detail').data('ihf-listing-number'),
				url: window.location.href,
			};
		} else if (document.getElementById('eap_details_one') !== null) {
			cookie.property = {
				mls: window.isDisplayPropertyMLSID || 0,
				url: window.location.href,
			};
		} else if (document.querySelector('.eap-search__results--is-lightbox') !== null) {
			cookie.property = {
				mls: document.querySelector('.eap-search__results--is-lightbox').dataset.mlsid,
				url: window.location.href,
			};
			// console.warn("it's lightbox mode");
		}
	}
	return cookie;
};

const saveVisitItems = visit => {
	localStorage.setItem(EAP_EXPORT_VISIT_DATA, JSON.stringify(visit));
	return visit;
};
const createCookie = (visit, type) => {
	const handledVisits = visit.length > 2 ? [] : visit;
	handledVisits.push(cookieFactory(type, `User visited this page: ${window.location.href}`));
	saveVisitItems(handledVisits);
};
const removeVisitItems = () => localStorage.removeItem(EAP_EXPORT_VISIT_DATA);
const getVisitItems = () => localStorage.getItem(EAP_EXPORT_VISIT_DATA);

const getLeadId = () => localStorage.getItem(EAP_EXPORT_ID_COOKIE);
const setLeadId = id => localStorage.setItem(EAP_EXPORT_ID_COOKIE, id);

const EAP_EXTERNAL = {
	run() {
		try {
			if (typeof window.eap_tracker === 'undefined') {
				return;
			}
			if (window.eap_tracker.on === true || window.eap_tracker.on === '1') {
				this.weShouldLogEvent();
			}
		} catch (error) {
			console.warn(`error running EAP_EXTERNAL crm activity tracker`, error.message);
		}
	},
	weShouldLogEvent() {
		const isProperty = window.isDisplayPropertyTracker || false;
		const isSearch = window.isSearchPerformedTracker || false;

		console.warn(`search performed`, { isSearch, isProperty });
		if (isProperty) {
			this.log(TYPES_OF_EVENTS.PROPERTY);
		} else if (isSearch) {
			this.log(TYPES_OF_EVENTS.SEARCH);
		} else {
			this.log();
		}
	},
	log(type) {
		try {
			const handledType = type || TYPES_OF_EVENTS.VISIT;
			console.warn(`running init for type: ${handledType}`);

			let visit = [];
			if (getVisitItems()) {
				visit = JSON.parse(getVisitItems());
			}

			createCookie(visit, handledType);
			this.exportCookie();
		} catch (error) {
			console.warn(`Error calling export.log directly`, { error });
		}
	},
	setContactId(id) {
		if (!id) {
			return;
		}
		setLeadId(id);
	},
	exportCookie() {
		const lead_id = getLeadId();
		if (!lead_id) {
			return;
		}

		const data = {};
		data.action = 'eap_external_export_api';
		data.lead_id = lead_id;
		data.final_visit = JSON.parse(getVisitItems());

		jQuery.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			dataType: 'json',
			data,
			success() {
				removeVisitItems();
			},
			error() {
				removeVisitItems();
			},
		});
	},
};

export default EAP_EXTERNAL;
